import { useEffect, useRef } from 'react';
import { useMedplum } from '@medplum/react';
import { useSessionTimeout } from '../hooks/useSessionTimeout';
import { SessionTimeoutModal } from './SessionTimeoutModal';

/**
 * Headless component that manages session timeout.
 * Renders no visible DOM except the warning modal when triggered.
 * Place as a sibling of <Routes> inside the authenticated branch.
 */
export function SessionTimeoutGuard() {
  const medplum = useMedplum();
  const { phase, secondsRemaining, resetTimer } = useSessionTimeout(true);
  const hasLoggedOut = useRef(false);

  // Handle expired phase — auto-logout
  useEffect(() => {
    if (phase === 'expired' && !hasLoggedOut.current) {
      hasLoggedOut.current = true;
      medplum.signOut().then(() => {
        window.location.href = '/signin';
      }).catch(() => {
        window.location.href = '/signin';
      });
    }
  }, [phase, medplum]);

  const handleLogout = () => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;
    medplum.signOut().then(() => {
      window.location.href = '/signin';
    }).catch(() => {
      window.location.href = '/signin';
    });
  };

  return (
    <SessionTimeoutModal
      opened={phase === 'warning'}
      secondsRemaining={secondsRemaining}
      onStayLoggedIn={resetTimer}
      onLogout={handleLogout}
    />
  );
}
